<template>
<div class="tab-wrapper" >
  <h3 class="mb16">付款计划</h3>
  <div class="content">
    <div class="item pt16 pb16">
      <table-list 
      :columns="columns" 
      :data="tableData" 
      :loading="loading"
      :current="current"
      :total="total" 
      @change-page="changPage"></table-list>
    </div>
  </div>
</div>
 
</template>
 
<script type="text/ecmascript-6">
 import TableList from "components/TableList/index";
 import { getParentContractBillInfo } from 'api/auditContract'
export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    parentContractFid:{
      type:String,
      default:''
    }
  },
  created(){
    this.getBillInfo(1)     
  },
  watch:{
    n(val){
      this.getBillInfo(1)     
    }
  },
components:{
  TableList
},
 data () {
  return {
    loading:false,
    current:1,
    total:0,
    columns:[
      {
      title: "房间号",
      key: "stockNumber",
      align: "center"
     
    },
    {
      title: "期数",
      key: "periods",
      align: "center"
     
    },
    {
      title: "款项",
      key: "costCodeName",
      align: "center"
    },
    {
      title: "应收款日期",
      key: "preCollectionDate",
      align: "center"
    },
    {
      title: "账单周期",
      key: "billsycleStarttime",
      align: "center",
      width:180,
      render: (h,params)=>{
        return h('div',params.row.billsycleStarttime+'至'+params.row.billsycleEndtime)
      }
    },
    {
      title: "应收",
      key: "receiptBillAmount",
      align: "center",
      render: (h,params) => {
        let receiptBillAmount = params.row.receiptBillAmount === 0 ? 0 : (params.row.receiptBillAmount/100).toFixed(2)
        return h('span',(params.row.receiptBillAmount/100).toFixed(2))
      }
    },
    {
      title: "已收",
      key: "receivedBillAmount",
      align: "center",
      render: (h,params) => {
        let receivedBillAmount = params.row.receiptBillAmount === 0 ? 0 : (params.row.receiptBillAmount/100).toFixed(2)
        return h('span',receivedBillAmount)
      }
    },
    {
      title: "状态",
      key: "verificateStatusName",
      align: "center"
    },
    {
      title: "账单编号",
      key: "billNum",
      align: "center"
    }
    ],
   tableData:[]
 };
 },
 methods:{
   changPage(n){
      this.current = n;  
      this.getBillInfo(n)
    },
    getBillInfo(n){
     let params = {
        page:n,
        limit:10,
        parentContractFid:this.parentContractFid
      }
     getParentContractBillInfo(params).then( res => {
        this.tableData = res.data.rows
        this.total = res.data.total
      })
   }
 }
}
</script>




